import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { EditableProcedureData } from "../../../../types/editableTreatmentPlan";
import ToothSelectionSelect from "../../../../components/ToothSelectionSelect";
import { TreatmentStepEditChips } from "../TreatmentStepChips";
import { EditAddCodeButtonWrapper } from "./EditTreatmentAppointment.styled";

export const MAX_TEETH_PER_STEP = 8;

export interface EditProcedureToothFieldProps {
  appointmentId: number;
  procedureIndex: number;
  procedure: EditableProcedureData;
  onChange: (teeth: string[]) => void;
}

const EditProcedureToothField: React.FC<EditProcedureToothFieldProps> = ({
  appointmentId,
  procedureIndex,
  procedure,
  onChange,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const hasCdtCode = procedure.resolvedCdtCodes.length > 0;

  const handleRemove = (value: string) => {
    onChange(procedure.teeth.filter((tooth) => tooth !== value));
  };

  const handleChange = (teeth: string[]) => {
    onChange(teeth.slice(0, MAX_TEETH_PER_STEP));
  };

  return (
    <EditAddCodeButtonWrapper>
      <TreatmentStepEditChips
        values={procedure.teeth}
        onRemove={handleRemove}
        onAddClick={() => setOpen(true)}
        disabled={!hasCdtCode}
        disabledReason={t("treatmentPlan.selectCdtCodeFirst")}
      />
      <ToothSelectionSelect
        hideTrigger
        open={open && hasCdtCode}
        onOpenChange={(nextOpen) => {
          if (!hasCdtCode) {
            setOpen(false);
            return;
          }
          setOpen(nextOpen);
        }}
        name={`tooth-${appointmentId}-${procedureIndex}`}
        value={procedure.teeth}
        onChange={handleChange}
        maxValues={MAX_TEETH_PER_STEP}
      />
    </EditAddCodeButtonWrapper>
  );
};

export default EditProcedureToothField;
